import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'

@Component({
    selector: 'select-live-search',
    templateUrl: './select-live-search.component.html',
})
export class SelectLiveSearchComponent implements OnInit, OnChanges {
    /*
        Este componente foi criado para construir um select com a opção de filtrar seu conteúdo.
        É necessário instanciar este componente da seguinte maneira:

        <select-live-search
            [attributeNameOfContentObjectOnListToOutput] = "'string'"
            [list] = 'array'
            [inputPlaceholder] = "'string'"
            [selectedContent] = 'string'
            (getSelectedContent) = 'função que recebe o conteúdo da opção selecionada no select'
        >
        </select-live-search>

        ## Os atributos a serem enviados para que o componente funcione são:

        ** list: É necessário que um array seja enviado e que este seja composto por objetos. O componente não funcionará caso receba um array diferente de objetos!

        ** attributeNameOfContentObjectOnListToOutput: Aqui é enviado uma string informando qual o atributo do objeto da lista que será exibido nas opções do select. Por exemplo. No caso do envio de uma lista com objetos { name: 'blá-blá' } a string enviada aqui deve ser 'name' para que o valor do atributo name seja exibido nas opções.
        Este mesmo atributo é o que será utilizado na comparação de conteúdo no filtro. Seguindo o exemplo acima o componente apenas verifica se o conteúdo digitado para pesquisa é compativel com o atributo name e logo só retornaria alguma coisa se o conteúdo digitado fosse algo similar a blá-blá.

        ** inputPlaceholder: É o placeholder que será exibido no input do componente

        ** selectedContent: Váriavel que será associada ao atributo selecionado. Isso é necessário para que o campo selecionado possa ser manipulado
        através da regra de negócio do arquivo ts que está utilizando este componente.
        Por exemplo. Eu quero colocar na minha tela que usa este componente um botão de limpar todos os campos.
        Se eu limpar a variavél associada a este atributo selectedContent o campo selecionado neste componente também será limpo.

        ## IMPORTANTE

        O filtro apenas é realizado com dados do tipo string. Caso queira enviar objetos para realizar filtros com números é necessário efetuar um toString
        em seu conteúdo.
    */

    @Input() hasError = false
    @Input() attributeNameOfContentObjectOnListToOutput: any
    @Input() list: any
    @Input() inputPlaceholder: any
    @Input() selectedContent: any
    @Input() disabledSelect: any
    @Input() controlName = ''
    @Output() getSelectedContent = new EventEmitter<any>()
    @Output() onBlur = new EventEmitter()

    originalListToFilter: any
    listToFilter: any

    ngOnInit() {
        if (this.list !== undefined && this.attributeNameOfContentObjectOnListToOutput !== undefined) this.startFilterList()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['list']) {
            this.startFilterList()
        }
    }

    startFilterList() {
        this.originalListToFilter = this.list
        this.originalListToFilter.map((content: any) => {
            if (content[`${this.attributeNameOfContentObjectOnListToOutput}`]) {
                content.contentToShowOnSelectOption = content[`${this.attributeNameOfContentObjectOnListToOutput}`]
            }
        })
        this.listToFilter = this.originalListToFilter
    }

    runLiveSearchOnList() {
        this.listToFilter = this.list
        if (this.selectedContent !== '' && this.selectedContent !== null && this.selectedContent !== undefined) {
            this.listToFilter = this.listToFilter.filter((content: any) =>
                content[`${this.attributeNameOfContentObjectOnListToOutput}`]
                    .toString()
                    .toLowerCase()
                    .includes(this.selectedContent.toString().toLowerCase()),
            )
        }
    }

    setSelectedContent(contentToReturn: any) {
        this.selectedContent = contentToReturn[`${this.attributeNameOfContentObjectOnListToOutput}`]
        this.getSelectedContent.emit(contentToReturn)
    }
}
